import { DialogService } from '@app/shared/services/shared/dialog.service';
import { TimeReportsDataService } from '@app/shared/services/time-reports-data.service';
import { TimeReportType } from '@app/shared/types/models/reports/time-report';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

export type MixedReportsAddRefresh = Pick<TimeReportsDataService, 'loadTimeReports' | 'reloadTimeReports'>;

export function startMixedReportsAdd(
  dialogService: Pick<
    DialogService,
    'openTimeReportTypeSelectorDialog' | 'openTimeReportDialog' | 'openAbsenceReportDialog'
  >,
  range: { start: Date; end: Date },
  timeReports: MixedReportsAddRefresh
): Observable<unknown> {
  return dialogService
    .openTimeReportTypeSelectorDialog()
    .afterClosed()
    .pipe(
      switchMap((choice: TimeReportType | undefined) =>
        openSelectedAddDialog(dialogService, choice, range).pipe(
          tap(result => {
            if (!result) {
              return;
            }
            if (choice === 'Absence') {
              timeReports.reloadTimeReports(range.start, range.end);
              return;
            }
            if (choice === 'WorkTime') {
              // Force a canonical refetch: loadTimeReports caches an already-loaded range, but the
              // POST row alone may not carry backend-calculated duration / component-duration fields.
              timeReports.reloadTimeReports(range.start, range.end);
            }
          })
        )
      )
    );
}

function openSelectedAddDialog(
  dialogService: Pick<DialogService, 'openTimeReportDialog' | 'openAbsenceReportDialog'>,
  choice: TimeReportType | undefined,
  range: { start: Date; end: Date }
): Observable<unknown> {
  if (choice === 'WorkTime') {
    return dialogService
      .openTimeReportDialog(undefined, undefined, undefined, 'WorkTime', range.start, range.end)
      .afterClosed();
  }
  if (choice === 'Absence') {
    return dialogService
      .openAbsenceReportDialog({
        dateFrom: range.start,
        dateTo: range.end
      })
      .afterClosed();
  }
  return of(undefined);
}
